import { gql, useQuery, NetworkStatus } from '@apollo/client';

export const GET_OFFER_PAYOUT_LOGS = gql`
  query GetOfferPayoutLogs($id: Int!, $source: String!) {
    getOfferPayoutLogs(id: $id, source: $source) {
      ruleTitle
      totalPayout
      lineItems {
        id
        name
        payout
      }
      orderPlacedAt
      orderSubtotal
    }
  }
`;

export interface OfferPayoutLogsData {
  getOfferPayoutLogs: {
    ruleTitle: string;
    totalPayout: number;
    lineItems: {
      id: string;
      name: string;
      payout: number;
    }[] | null;
    orderPlacedAt: Date;
    orderSubtotal: number;
  }[];
}

export interface OfferPayoutLogsVars {
  id: number;
  source: string;
}

export function useGetOfferPayoutLogs(id: number | null, source: string) {
  const { data, loading, error, networkStatus, refetch } = useQuery<OfferPayoutLogsData, OfferPayoutLogsVars>(GET_OFFER_PAYOUT_LOGS, {
    variables: {
      id: id || 0,
      source,
    },
    skip: !id,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    data,
    loading: loading || networkStatus === NetworkStatus.refetch,
    error,
    refetch,
    networkStatus
  };
}
